import graphql from './graphql';

const mapRoles = data => {
  if (!data?.Role_list) return [];
  return data.Role_list.map(role => [role.name || 'sin nombre', role.id]);
};

const fetch = async () => {
  const promises = [];
  promises.push(graphql('Role_list', 'id name', 'query').catch(() => []));
  const data = await Promise.all(promises);
  const roles = mapRoles(data[0]);

  return { roles };
};
export default fetch;
